import { motion, useTransform, useViewportScroll } from 'framer-motion'
import React, { useRef, useEffect } from 'react'
import { useWindowSize } from 'react-use'
import { useInView } from 'react-intersection-observer'
import useMeasure from 'react-use-measure'
import DynamicLink from '../atoms/DynamicLink'

const TeaserLiftSection = ({ lift }) => {
  const videoRef = useRef()
  const [ref, measurements] = useMeasure({ debounce: 5, scroll: true })
  const { ref: inViewRef, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  })
  const { width: winWidth, height: winHeight } = useWindowSize()
  const { scrollY } = useViewportScroll()

  let scrollTop = 0
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    scrollTop = window?.pageYOffset || document?.documentElement.scrollTop || 0
  }
  const animationStart = measurements.top + scrollTop - winHeight * 0.8
  const animationEnd = animationStart + 1.2 * winHeight
  const isMobile = winWidth < 1024
  const yMobileTransform = lift.roundImage ? 10 : 50
  const yTransformStart = isMobile ? yMobileTransform : -100
  const yTransformEnd = isMobile ? 0 : 50
  const y = useTransform(
    scrollY,
    [animationStart, animationEnd],
    [yTransformStart, yTransformEnd],
  )

  useEffect(() => {
    if (inView) {
      videoRef.current?.play()
    } else if (videoRef.current) {
      videoRef.current?.pause()
      videoRef.current.currentTime = 0
    }
  }, [inView])

  return (
    <div ref={ref} className="row-type-f">
      <div className="z-10 col-1-type-f" ref={inViewRef}>
        <div className="column-indent">
          <h2 className="mb-5 u-h1">{lift.heading}</h2>
          <div className="column-indent-both">
            <div
              className="mb-6 u-p link-wrapper"
              dangerouslySetInnerHTML={{ __html: lift.copy }}
            />
            <DynamicLink className="u-btn" link={lift.button} />

            {lift.copy2 && (
              <>
                <div
                  className="mt-12 mb-6 u-p link-wrapper"
                  dangerouslySetInnerHTML={{ __html: lift.copy2 }}
                />
                <DynamicLink className="u-btn" link={lift.button2} />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-2-type-f">
        <motion.div style={{ y }}>
          {lift.videos.length > 0 && (
            <video
              width="auto"
              height="100%"
              muted
              playsInline
              ref={videoRef}
              fetchpriority="high"
            >
              <source
                src={
                  lift.videos.find(({ extension }) => extension === 'mp4')?.url
                }
                type='video/mp4; codecs="hvc1"'
              />
              <source
                src={
                  lift.videos.find(({ extension }) => extension === 'webm')?.url
                }
                type="video/webm"
              />
            </video>
          )}
          {lift.image.length > 0 && (
            <img
              src={lift.image[0].url}
              alt={lift.heading}
              className={`${
                lift.roundImage ? 'rounded shadow-tpmp lg:shadow-dp' : ''
              } w-full h-auto`}
            />
          )}
          {lift.youtubeId && (
            <iframe
              title={lift.heading}
              src={`https://www.youtube.com/embed/${lift.youtubeId}?modestbranding=1&rel=0`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full aspect-video rounded-[5px] shadow-tpmp"
            ></iframe>
          )}
        </motion.div>
      </div>
    </div>
  )
}

export default TeaserLiftSection
